var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.sideBarStatus ? 'md:pr-64' : 'pr-0', 'duration-700'],attrs:{"id":"layoutPage"}},[_c('sidebar'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }